export default "__VITE_ASSET__CylSoobu__"